import { PAYMENT_METHODS, SERVICES } from '@autopass-web/domain';

import Client from '../client';

import type { ConfirmPaymentInfo, PaymentInfo, Receipt } from './types';

interface CreateLinePaySessionProps {
  paymentInfo: PaymentInfo;
  receipt: Receipt;
  email: string | undefined;
}

export const createLinePaySession = async ({
  paymentInfo,
  receipt,
  email,
}: CreateLinePaySessionProps) => {
  const callbackUrlParams = new URLSearchParams({
    paymentType: PAYMENT_METHODS.LINE_PAY,
    serviceType: SERVICES.APS,
    parkingTicketId: paymentInfo.id,
    plateNumber: paymentInfo.plateNumber,
  });

  const callbackUrl = `${
    window.location.origin
  }/auth?${callbackUrlParams.toString()}`;

  const { data } = await Client.createLinePaySession({
    callbackUrl,
    parkingTicketId: paymentInfo.id,
    email,
    receipt,
  });

  return data.data.web_link;
};

interface ConfirmLinePayTransactionProps {
  confirmPaymentInfo: ConfirmPaymentInfo;
}

export const confirmLinePayTransaction = async ({
  confirmPaymentInfo,
}: ConfirmLinePayTransactionProps) => {
  const { data } = await Client.apsGetOrder({
    parkingTicketId: confirmPaymentInfo.parking_ticket_id as string,
    parkingOrderId: confirmPaymentInfo?.parking_order_id as string,
  });

  return data;
};
